import Jt808MonitoringsViewModal from './jt808-monitoring-view-modal.vue'
export default Jt808MonitoringsViewModal
